<template>
  <v-container id="my-groups" fluid tag="section">
    <v-overlay :value="isOverlayVisible">
      <v-progress-circular :size="70" :width="7" color="amber" indeterminate class="spinner" />
    </v-overlay>

    <template>
      <v-toolbar flat color="transparent">
        <v-spacer />

        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="isAdmin" color="primary" dark class="mb-2 ml-4" v-bind="attrs" v-on="on">
              <v-icon small class="mr-2"> mdi-plus </v-icon>
              New Static Group
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem.name"
                      required
                      label="Name *"
                      :error="!editedItem.name && isFormDirty"
                    />
                  </v-col>
                </v-row>
              </v-container>
              <small>* indicates required field</small>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn color="secondary" text @click="close"> Cancel </v-btn>
              <v-btn color="primary" text @click="save"> Save </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <v-data-table :headers="headers" :items="groups" sort-by="name" class="elevation-1">
      <template v-slot:[`item.actions`]="{ item }">
        <div class="senderActions">
          <div class="commBtnWrapper">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="quick-comm-btn"
                  @click="_showIvrCallInitiator(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-phone</v-icon>
                </button>
              </template>
              <span>Initiate IVR</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="quick-comm-btn"
                  @click="_showBulkEmailComposer(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-email-edit</v-icon>
                </button>
              </template>
               <span>Compose Email</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="quick-comm-btn"
                  @click="_showBulkMessageComposer(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-message-draw</v-icon>
                </button>
              </template>
              <span>Compose SMS</span>
            </v-tooltip>
          </div>
          <router-link
            :to="{
              name: 'Manage Group Patients',
              params: { groupId: item.GroupID }
            }"
          >
            <v-btn color="primary" outlined x-small class="ml-4">
              View Patients
            </v-btn>
          </router-link>
          <v-btn color="primary" outlined x-small class="ml-4" @click="_editGroup(item)">
            Edit
          </v-btn>
          <v-btn
            color="primary"
            outlined
            x-small
            class="addPatientsBtn"
            @click="_showPatientAddDialog(item)"
          >
            Add Patients
          </v-btn>
          <v-icon class="ml-4" v-if="isAdmin" small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </div>
      </template>
      <template v-slot:no-data>
        <p class="mb-4 mt-4">No groups to display</p>
        <v-btn color="primary" outlined class="mb-4" @click="_initialize">
          Refresh
        </v-btn>
      </template>
    </v-data-table>

    <add-patients-to-group-dialog
      :is-visible="addPatientDialog.isActive"
      :selected-group-id="addPatientDialog.selectedGroupId"
      :selected-group-name="addPatientDialog.selectedGroupName"
      @on-success="_onPatientAddSuccess"
      @on-close="_hidePatientAddDialog"
    />

    <!-- <share-group-dialog
      :selected-group="selectedGroupToShare"
      :is-visible="isGroupShareDialogVisible"
      :users="allUsers"
      @on-submit="onGroupShareSubmit"
      @on-close="hideGroupShareDialog"
      @on-success="onGroupShareSuccess"
      @on-error="onGroupShareError"
    /> -->

    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <div class="py-3" />
  </v-container>
</template>

<script>
  /* eslint-disable */
import { ApiCalls } from "../../../../api-calls";
import EventEmitter from "../../../../utils/event-emitter";
import HelperMethods from "../../../../utils/helper-methods";
import UserHelper from "../../../../utils/user-helper";
import AddPatientsToGroupDialog from "../add-patients-to-group-dialog/add-patients-to-group-dialog.vue";

export default {
  components: {
    AddPatientsToGroupDialog
    // ShareGroupDialog: () => import('../components/ShareGroupDialog'),
  },
  data: () => ({
    dialog: false,
    headers: [
      { text: "Name", value: "Name" },
      { text: "Patients", value: "MemberCnt" },
      { text: "Notes", value: "Notes" },
      // { text: "Messages", value: "MessageCnt" },
      { text: "Actions", value: "actions", sortable: false }
    ],
    snackbar: false,
    notification: "Unknown",
    groups: [],
    editedIndex: -1,
    editedItem: {
      id: -1,
      name: "",
      members: "-",
      messages: "-"
    },
    defaultItem: {
      id: -1,
      name: "",
      members: "-",
      messages: "-"
    },
    senders: [],
    isOverlayVisible: false,
    selectedSenderID: null,
    isFormDirty: false,
    selectedGroupToShare: null,
    isGroupShareDialogVisible: false,
    allUsers: [],
    isAdmin: false,
    addPatientDialog: {
      isActive: false,
      selectedGroupId: null,
      selectedGroupName: null
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Static Group" : "Edit Static Group";
    },
    activePractice() {
      console.log('Manage Static Groups computed' + this.$store.state.posActivePractice);
      return this.$store.state.posActivePractice.value;
    }
  },

  watch: {
    dialog(val) {
      // eslint-disable-next-line no-unused-expressions
      val || this.close();
    },
    '$store.state.posActivePractice': function () {
      this._initialize();
    },
  },

  async created() {
    this.isAdmin = UserHelper.checkIfHasPracticeAdminAccess();
    await this._initialize();
  },

  methods: {
    async _initialize() {
      await HelperMethods.sleepTime(400);
      await this._loadGroups();
      await this._loadSenders();
    },
    async _loadGroups() {
      try {
        this.isOverlayVisible = true;
        const response = await ApiCalls.fetchGroups(this.activePractice);
        this.groups = response && response.data && response.data.length ? response.data : [];
        // eslint-disable-next-line no-empty
      } catch (error) {
        this.groups = [];
      }
      this.isOverlayVisible = false;
    },
    async _loadSenders() {
      try {
        this.isOverlayVisible = true;
        const response = await ApiCalls.fetchSenders();
        this.senders =
          response && response.data && response.data.length
            ? response.data.map(s => ({
                text: s.senderName,
                value: s.senderID
              }))
            : [];
        // eslint-disable-next-line no-empty
      } catch (error) {
        this.senders = [];
      }
      this.isOverlayVisible = false;
    },

    updateSender(senderID) {
      this.selectedSenderID = senderID;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = {
          id: -1,
          name: "",
          members: "-",
          messages: "-"
        };
        this.editedIndex = -1;
        this.selectedSenderID = null;
        this.isFormDirty = false;
      });
    },
    async save() {
      if (!(this.editedItem.name && this.editedItem.name.length)) {
        this.notification = "Please provide a group name";
        this.snackbar = true;
        return;
      }

      let activePracticeId = this.activePractice;

      if (!activePracticeId && !activePracticeId.value) {
        this.notification = "Unable to get activePracticeId from the store.";
        this.snackbar = true;
      }

      const activegroupId = this.editedItem.id;
      this.isOverlayVisible = true;
      if (this.editedIndex > -1) {
        // edit group
        try {
          await ApiCalls.updateGroup(activegroupId, {
            Name: this.editedItem.name
          });
          await this._loadGroups();
        } catch (error) {
          this.notification = "Unable to update group";
          this.snackbar = true;
        }
      } else {
        // New group
        try {
          await ApiCalls.createGroup({
            Name: this.editedItem.name,
            PracticeID: activePracticeId
          });
          await this._loadGroups();
        } catch (error) {
          this.notification = "Unable to create group";
          this.snackbar = true;
        }
      }
      this.isOverlayVisible = false;
      this.close();
    },
    _editGroup(item) {
      this.formTitle = "Edit Static Group";
      this.editedItem = {
        id: item.GroupID,
        name: item.Name
      };
      this.editedIndex = 0;
      this.dialog = true;
    },
    async deleteItem(item) {
      if (window.confirm("Are you sure you want to delete this group?")) {
        if (item.GroupID) {
          try {
            await ApiCalls.deleteGroup(item.GroupID);
            this.notification = "Group has been deleted";
            this.snackbar = true;
            await this._loadGroups();
          } catch (error) {
            this.notification = "Unable to delete the group";
            this.snackbar = true;
          }
        } else {
          this.notification = "Group id not available";
          this.snackbar = true;
        }
      }
    },
    _showBulkMessageComposer(group) {
      EventEmitter.dispatch("show-group-bulk-sms-composer", {
        selectedGroupType: "static",
        selectedGroup: group
      });
    },
    _showBulkEmailComposer(group) {
      EventEmitter.dispatch("show-group-bulk-email-composer", {
        selectedGroupType: "static",
        selectedGroup: group
      });
    },
    _showIvrCallInitiator(group) {
      EventEmitter.dispatch("show-group-bulk-ivr-composer", {
        selectedGroupType: "static",
        selectedGroup: group
      });
    },
    _showPatientAddDialog(group) {
      this.addPatientDialog = {
        isActive: true,
        selectedGroupId: group.GroupID,
        selectedGroupName: group.Name
      };
    },
    _hidePatientAddDialog() {
      this.addPatientDialog = {
        isActive: false,
        selectedGroupId: null,
        selectedGroupName: null
      };
    },
    _onPatientAddSuccess() {
      this._hidePatientAddDialog();
      this._loadGroups();
    }
  }
};
</script>

<style scoped lang="scss">
@import url("./manage-static-groups.scss");
.senderActions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.commBtnWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.quick-comm-btn {
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  margin-right: 15px;
  align-items: center;
  background-color: rgb(0, 114, 44);
  box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.12);
  color: white;
  font-size: 12px;
  * {
    font-size: 12px;
    color: white;
  }
  border-radius: 100px;
}
.addPatientsBtn {
  margin: 0 16px !important;
}
</style>
